import styled from 'styled-components'
import NextImage from 'next/image'

import Icon from '../Icon'

export const ColumnSectionCard = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.pureBlack};
  transition: opacity 0.15s;
  &:hover {
    opacity: 0.8;
  }
`

export const Image = styled(NextImage)``
export const IconStyled = styled(Icon)``

export const Title = styled.h3`
  ${({ theme }) => theme.textStyles.bebas3Xl};
  line-height: 2.4rem;
  color: ${({ theme }) => theme.colors.pinkPrimary};
  margin-block: 3.8rem 0;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratLg}
  margin-top: 2rem;
`
